import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useGlobalMonitoringAlerts } from '../contexts/GlobalMonitoringAlertContext';

/**
 * Top alert bar for cross-module monitoring thresholds (storage / CPU / memory / network).
 * Hidden when there are no active threshold messages.
 */
const GlobalAlertBar: React.FC = () => {
  const { thresholdAlerts, dismissThresholdAlerts } = useGlobalMonitoringAlerts();

  if (thresholdAlerts.length === 0) {
    return null;
  }

  return (
    <div
      className="flex-shrink-0 border-b border-red-800/30 bg-red-700 text-white shadow-md"
      role="alert"
    >
      <div className="px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-start gap-2 gap-y-2">
        <span className="font-semibold text-sm uppercase tracking-wide shrink-0 pt-0.5" aria-hidden>
          Alert
        </span>
        <ul className="text-sm flex-1 min-w-0 leading-snug list-disc list-inside space-y-1">
          {thresholdAlerts.map((msg) => (
            <li key={msg}>{msg}</li>
          ))}
        </ul>
        <div className="flex items-center gap-1 shrink-0 ml-auto sm:ml-0">
          <button
            type="button"
            onClick={dismissThresholdAlerts}
            className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs font-medium text-red-100 hover:bg-red-800/60 focus:outline-none focus:ring-2 focus:ring-white/40"
          >
            Dismiss
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalAlertBar;
